import { APIProvider, Map } from "@vis.gl/react-google-maps";
import React, { useState } from "react";
import MapHandler from "./MapHandler";
import SearchControl from "./SearchControl";
import DrawingManager from "./DrawingManager";
import CustomZoomControl from "./CustomZoomControl";
import { Controller, useFormContext } from "react-hook-form";
import { MAP_STYLE } from "./styles";
//@ts-ignore: This is injected at compile time
const API_KEY = process.env.GOOGLE_MAPS_API_KEY;
const GoogleMap = () => {
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [zoom, setZoom] = useState(7);
    const { control, formState: { errors } } = useFormContext();
    return (React.createElement(Controller, { name: "locationArea", control: control, render: ({ field }) => (React.createElement(APIProvider, { apiKey: API_KEY },
            React.createElement(Map, { style: { width: '100%', height: '100%', minHeight: '400px', borderRadius: ".5rem", overflow: "hidden" }, defaultCenter: { lat: 52.47887871983876, lng: -1.8850462887029098 }, defaultZoom: 7, zoom: zoom, onZoomChanged: (e) => {
                    setZoom(e.detail.zoom);
                }, gestureHandling: 'greedy', disableDefaultUI: true, styles: MAP_STYLE }),
            React.createElement(SearchControl, { onPlaceSelect: setSelectedPlace }),
            React.createElement(CustomZoomControl, { zoom: zoom, onZoomChange: setZoom }),
            React.createElement(DrawingManager, { area: field.value, onChange: (area) => {
                    console.log("Change area", area);
                    field.onChange(area);
                } }),
            React.createElement(MapHandler, { place: selectedPlace }))) }));
};
export default GoogleMap;
